import React, { Component } from 'react';
import {
	Grid,
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	TextField,
	Typography,
	Box,
	Paper,
	Button
} from '@mui/material';

class FormSearch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fechas: {
				fechaInicio: '2014-02-14',
				fechaFin: '2024-02-12'
			},
			tipoConsulta: 'cuadrante',
			coordenadas: {
				longitudMin: '-90',
				longitudMax: '-66',
				latitudMin: '-07',
				latitudMax: '15',
			},
			centroRadio: {
				latitudCentral: '5',
				longitudCentral: '-76',
				radio: '100',
			},
			magnitud: {
				minMagnitude: '0',
				maxMagnitude: '9'
			},
			profundidad: {
				minDepth: '0',
				maxDepth: '200'
			},
			rms: {
				minRms: '0',
				maxRms: '22'
			},
			gap: {
				minGap: '0',
				maxGap: '360'
			},
			errorProf: {
				minEprof: '0',
				maxEprof: '999'
			},
			errorLong: {
				minElong: '0',
				maxElong: '999'
			},
			errorLat: {
				minElat: '0',
				maxElat: '999'
			}
		};
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleTipoConsultaChange = (e) => {
		this.setState({ tipoConsulta: e.target.value });
	};

	handleInputChange = (seccion, campo, valor) => {
		this.setState((prevState) => ({
			[seccion]: {
				...prevState[seccion],
				[campo]: valor
			}
		}));
	};


	handleSubmit(event) {
		event.preventDefault()
		this.props.onAction("searchData", this.state)
	};

	render() {
		const { tipoConsulta, coordenadas, centroRadio, magnitud, profundidad, rms, gap, errorProf, errorLong, errorLat, fechas } = this.state;

		return (
			<form id="form-search-tecto" onSubmit={this.handleSubmit}>
				<Box sx={{ backgroundColor: '#f0f0f0', minHeight: '100vh', py: 4 }}>
					<Paper elevation={3} sx={{ maxWidth: 900, mx: 'auto', p: 4, borderRadius: 2, backgroundColor: '#e6f4ea' }}>
						<Box sx={{ mb: 3 }}>
							<Typography variant="h6" gutterBottom>Rango de Fechas</Typography>
							<Grid container spacing={6}>
								<Grid item xs={12} sm={6}>
									<TextField
										label="Fecha Inicial"
										type="date"
										fullWidth
										InputLabelProps={{ shrink: true }}
										value={fechas.fechaInicio}
										onChange={(e) => this.handleInputChange('fechas', 'fechaInicio', e.target.value)}
										inputProps={{ min: '2014-02-14', max: '2024-02-12' }}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										label="Fecha Final"
										type="date"
										fullWidth
										InputLabelProps={{ shrink: true }}
										value={fechas.fechaFin}
										onChange={(e) => this.handleInputChange('fechas', 'fechaFin', e.target.value)}
										inputProps={{ min: '2014-02-14', max: '2024-02-12' }}
									/>
								</Grid>
							</Grid>
						</Box>
						{/* Tipo de consulta */}
						<FormControl component="fieldset" sx={{ mb: 3 }}>
							<Typography variant="h6" gutterBottom>Tipo de Consulta</Typography>
							<RadioGroup row value={tipoConsulta} onChange={this.handleTipoConsultaChange}>
								<FormControlLabel value="cuadrante" control={<Radio />} label="Consulta Cuadrante" />
								<FormControlLabel value="circular" control={<Radio />} label="Consulta Circular" />
							</RadioGroup>
						</FormControl>

						{/* Consulta Cuadrante */}
						{tipoConsulta === 'cuadrante' && (
							<Box sx={{ mb: 3 }}>
								<Typography variant="h6" gutterBottom>Coordenadas Límite</Typography>
								<Grid container spacing={6}>
									<Grid item xs={12} sm={6}>
										<TextField label="Longitud Mínima" type="number" fullWidth value={coordenadas.longitudMin} onChange={(e) => this.handleInputChange('coordenadas', 'longitudMin', e.target.value)} />
									</Grid>
									<Grid item xs={12} sm={6}>
										<TextField label="Longitud Máxima" type="number" fullWidth value={coordenadas.longitudMax} onChange={(e) => this.handleInputChange('coordenadas', 'longitudMax', e.target.value)} />
									</Grid>
									<Grid item xs={12} sm={6}>
										<TextField label="Latitud Mínima" type="number" fullWidth value={coordenadas.latitudMin} onChange={(e) => this.handleInputChange('coordenadas', 'latitudMin', e.target.value)} />
									</Grid>
									<Grid item xs={12} sm={6}>
										<TextField label="Latitud Máxima" type="number" fullWidth value={coordenadas.latitudMax} onChange={(e) => this.handleInputChange('coordenadas', 'latitudMax', e.target.value)} />
									</Grid>
								</Grid>
							</Box>
						)}

						{/* Consulta Circular */}
						{tipoConsulta === 'circular' && (
							<Box sx={{ mb: 3 }}>
								<Typography variant="h6" gutterBottom>Centro y Radio</Typography>
								<Grid container spacing={6}>
									<Grid item xs={12} sm={4}>
										<TextField label="Latitud Central" type="number" fullWidth value={centroRadio.latitudCentral} onChange={(e) => this.handleInputChange('centroRadio', 'latitudCentral', e.target.value)} />
									</Grid>
									<Grid item xs={12} sm={4}>
										<TextField label="Longitud Central" type="number" fullWidth value={centroRadio.longitudCentral} onChange={(e) => this.handleInputChange('centroRadio', 'longitudCentral', e.target.value)} />
									</Grid>
									<Grid item xs={12} sm={4}>
										<TextField label="Radio (km)" type="number" fullWidth value={centroRadio.radio} onChange={(e) => this.handleInputChange('centroRadio', 'radio', e.target.value)} />
									</Grid>
								</Grid>
							</Box>
						)}

						{/* Rango de Magnitud */}
						<Box sx={{ mb: 3 }}>
							<Typography variant="h6" gutterBottom>Rango de Magnitud</Typography>
							<Grid container spacing={6}>
								<Grid item xs={12} sm={6}>
									<TextField label="Magnitud Mínima" type="number" fullWidth value={magnitud.minMagnitude} onChange={(e) => this.handleInputChange('magnitud', 'minMagnitude', e.target.value)} />
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField label="Magnitud Máxima" type="number" fullWidth value={magnitud.maxMagnitude} onChange={(e) => this.handleInputChange('magnitud', 'maxMagnitude', e.target.value)} />
								</Grid>
							</Grid>
						</Box>

						{/* Rango de Profundidad */}
						<Box sx={{ mb: 3 }}>
							<Typography variant="h6" gutterBottom>Rango de Profundidad</Typography>
							<Grid container spacing={6}>
								<Grid item xs={12} sm={6}>
									<TextField label="Profundidad Mínima (km)" type="number" fullWidth value={profundidad.minDepth} onChange={(e) => this.handleInputChange('profundidad', 'minDepth', e.target.value)} />
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField label="Profundidad Máxima (km)" type="number" fullWidth value={profundidad.maxDepth} onChange={(e) => this.handleInputChange('profundidad', 'maxDepth', e.target.value)} />
								</Grid>
							</Grid>
						</Box>

						{/* Rango de Erro RMS */}
						<Box sx={{ mb: 3 }}>
							<Typography variant="h6" gutterBottom>Rango RMS</Typography>
							<Grid container spacing={6}>
								<Grid item xs={12} sm={6}>
									<TextField label="RMS Mínima (seg)" type="number" fullWidth value={rms.minRms} onChange={(e) => this.handleInputChange('rms', 'minRms', e.target.value)} />
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField label="RMS Máxima (seg)" type="number" fullWidth value={rms.maxRms} onChange={(e) => this.handleInputChange('rms', 'maxRms', e.target.value)} />
								</Grid>
							</Grid>
						</Box>

						{/* Rango de GAP */}
						<Box sx={{ mb: 3 }}>
							<Typography variant="h6" gutterBottom>Rango GAP</Typography>
							<Grid container spacing={6}>
								<Grid item xs={12} sm={6}>
									<TextField label="GAP Mínimo (grados)" type="number" fullWidth value={gap.minGap} onChange={(e) => this.handleInputChange('gap', 'minGap', e.target.value)} />
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField label="GAP Máximo (grados)" type="number" fullWidth value={gap.maxGap} onChange={(e) => this.handleInputChange('gap', 'maxGap', e.target.value)} />
								</Grid>
							</Grid>
						</Box>

						{/* Rango de Error en Profundidad, Longitud, Latitud */}
						<Box sx={{ mb: 3 }}>
							<Typography variant="h6" gutterBottom>Rango Error en Profundidad, Longitud, Latitud</Typography>
							<Grid container spacing={6}>
								<Grid item xs={12} sm={6}>
									<TextField label="Error Profundidad Mínimo (km)" type="number" fullWidth value={errorProf.minEprof} onChange={(e) => this.handleInputChange('errorProf', 'minEprof', e.target.value)} />
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField label="Error Profundidad (km)" type="number" fullWidth value={errorProf.maxEprof} onChange={(e) => this.handleInputChange('errorProf', 'maxEprof', e.target.value)} />
								</Grid>
							</Grid>
							<br />
							<Grid container spacing={6}>
								<Grid item xs={12} sm={6}>
									<TextField label="Error Longitud Mínimo (km)" type="number" fullWidth value={errorLong.minElong} onChange={(e) => this.handleInputChange('errorLong', 'minElong', e.target.value)} />
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField label="Error Longitud (km)" type="number" fullWidth value={errorLong.maxElong} onChange={(e) => this.handleInputChange('errorLong', 'maxElong', e.target.value)} />
								</Grid>
							</Grid>
							<br />
							<Grid container spacing={6}>
								<Grid item xs={12} sm={6}>
									<TextField label="Error Latitud Mínimo (km)" type="number" fullWidth value={errorLat.minElat} onChange={(e) => this.handleInputChange('errorLat', 'minElat', e.target.value)} />
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField label="Error Latitud (km)" type="number" fullWidth value={errorLat.maxElat} onChange={(e) => this.handleInputChange('errorLat', 'maxElat', e.target.value)} />
								</Grid>
							</Grid>

							{/* Botón */}
							<div style={{ display: 'flex', justifyContent: 'center', marginTop: '24px' }}>
								<Button
									type="submit"
									variant="contained"
									color="success"
									className="boton-consultar"
								>
									Consultar
								</Button>
							</div>

						</Box>
					</Paper>
				</Box>
			</form>


		);
	}
}

export default FormSearch;